export interface DropDownOption<T> {
  value: T;
  viewValue: string;
}
